import React from "react"
import {Box} from "@mui/material";
import {CmCollection, CmTeasable, SosDonationProduct} from "../../../../packages/graphql-layer/src";
import CCOHeadline from "../../fundamentals/CCOHeadline";
import TeaserCard from "./TeaserCard";
import CCOContainer from "../../fundamentals/CCOContainer";
import getSetting, {
    SETTING_GALLERY_AUTOPLAY,
    SETTING_GALLERY_AUTOPLAY_SPEED,
    SETTING_GALLERY_IMAGESLIDE_SPEED
} from "../../../pages/config/settings";
import CCOComponentWrapper from "../../fundamentals/CCOComponentWrapper";
import {getKey} from "../../../utility/componentUtil";
import useWindowSize from "../../../utility/useWindowSize";
import ProductTeaserCard from "../C085ProductTeaser/ProductTeaserCard";
import dynamic from "next/dynamic";


export interface Props {
    cmCollection: CmCollection
    headline?: string
    background?: string
    isHeroCarousel?: boolean
    isSmall?: boolean
}

export function getContentClassName(id: string) {
    return `carousel-content-${id}`;
}

const CCOCarousel = dynamic(() => import('../../fundamentals/CCOCarousel'), {
    ssr: false
})


function C020TeaserCarousel(props: Props) {
    const carouselContentClassName = getContentClassName(getKey(props?.cmCollection?.id));
    const {lowerThanWindowMedium} = useWindowSize()

    function prepareItems(collectionItems: Array<any>) {
        const preparedItems: Array<any> = [];
        collectionItems.map((item: any, index: number) => {
            preparedItems.push(
                <Box
                    className={carouselContentClassName}
                    sx={{minWidth: "100%"}}
                    data-cypress={`carousel-item-${index}`}>
                    {
                        item.type === 'SOSDonationProduct' ?
                            <ProductTeaserCard item={item}/> :
                            <TeaserCard item={item}/>
                    }
                </Box>
            );
        });
        return preparedItems;
    }

    const isProduct = props.cmCollection.items &&
                      (props.cmCollection.items[0] as CmTeasable).type === 'SOSDonationProduct';

    function renderCarousel() {
        return <CCOCarousel
            autoPlay={getSetting((props.cmCollection as any).teaserCarouselSettings,
                                 SETTING_GALLERY_AUTOPLAY)}
            interval={getSetting((props.cmCollection as any).teaserCarouselSettings,
                                 SETTING_GALLERY_AUTOPLAY_SPEED)}
            duration={getSetting((props.cmCollection.items as any).teaserCarouselSettings,
                                 SETTING_GALLERY_IMAGESLIDE_SPEED)}
            items={prepareItems(props.cmCollection.items!)}
            paginateItems={true}
            contentClassName={carouselContentClassName}
            isHeroCarousel={props.isHeroCarousel}
        />;
    }

    function renderBox() {
        return props.cmCollection.items && props.cmCollection.items.length > 0 ? <Box>
            {isProduct ?
                <ProductTeaserCard
                    item={props.cmCollection.items[0] as SosDonationProduct}
                    horizontal={!lowerThanWindowMedium}
                /> :
                <TeaserCard
                    item={props.cmCollection.items[0]}
                    horizontal={!lowerThanWindowMedium}
                />
            }
        </Box> : null;
    }

    function renderElements() {
        return <>
            {props.cmCollection.items ?
                props.cmCollection.items.length > 1 ?
                    renderCarousel() :
                    renderBox()
                : null}
        </>;
    }

    return <CCOComponentWrapper
        background={'grey'}
        dataCypress='teaser-carousel'
        noBottomMargin={props.isHeroCarousel}
        noTopMargin={props.isHeroCarousel}
        {...(props.isHeroCarousel ? {customStyle: {paddingTop: 0}} : {})}
    >
        <CCOHeadline id={props.cmCollection.id}
                     metadataId={props.cmCollection.id}
                     propertyName={props.headline ? 'properties.headline' :
                         'properties.teaserTitle'}
                     subtextPropertyName='properties.teaserText'
                     headline={props.headline ? props.headline : props.cmCollection.teaserTitle}
                     type={"componenthead"}
                     subtext={props.cmCollection.teaserText?.textAsTree}
                     background={'grey'}/>
        <CCOContainer background={'grey'} width={"large"}>
            {
                props.isSmall ?
                    <CCOComponentWrapper>
                        <CCOContainer width='large'>
                            <CCOContainer width='large'>
                                {renderElements()}
                            </CCOContainer>
                        </CCOContainer>
                    </CCOComponentWrapper> :
                    renderElements()
            }
        </CCOContainer>
    </CCOComponentWrapper>
}

export default C020TeaserCarousel


